import { Decimal } from 'decimal.js';

export class PaymentPlanPromotionDto {
    id: string;

    number_of_weeks: number;

    amount: Decimal;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(rawPaymentPromotion: any) {
        this.id = rawPaymentPromotion.id;
        this.number_of_weeks = rawPaymentPromotion.number_of_weeks;
        this.amount = new Decimal(rawPaymentPromotion.amount);
    }
}
